"use client";
import { SimpleHero } from "trimble-terra"
import BlogArticleSearch from "../../components/client/SectionBlogDigest/Search/BlogArticleSearch";
import { getProfile } from '@/profiles/getProfile'
import { useEffect, useState } from "react";
import { SearchButton } from "trimble-terra"
import { processLinkUrl } from '@/utils/linkUtils'

export const NotFound = ({ notFoundData, lang = 'en-US', slug } : {
  notFoundData?: {
    header?: string;
    description?: string;
    backgroundImage?: {
      url?: string;
    };
    searchWindowTitle?: string;
    searchWindowDescription?: string;
    searchFieldPlaceholder?: string;
    searchResetText?: string;
    buttonsCollection?: {
      items?: any[]
    }
  },
  lang?: string,
  slug?: string[]
}) => {
  const [currentBlogSearchTerm, setCurrentBlogSearchTerm] = useState("")
  const [articleSearchModalOpen, setArticleSearchModalOpen] = useState(false)
  const [notFoundSlug, setNotFoundSlug] = useState<any>("")
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE)
  const algoliaData = { 
    algoliaId: profile.NEXT_PUBLIC_ALGOLIA_APP_ID, 
    algoliaKey: profile.NEXT_PUBLIC_ALGOLIA_API_KEY, 
    algoliaIndex: profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX, 
    algoliaHits: profile.NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE || 10 
  }

  const validSearchClient = (profile.NEXT_PUBLIC_ALGOLIA_APP_ID != undefined && 
  profile.NEXT_PUBLIC_ALGOLIA_API_KEY != undefined && 
  profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX != undefined) ? true : false;

  const searchComponentModalToggleHandler = () => {
    setArticleSearchModalOpen(!articleSearchModalOpen)
  }

  const handleSearch = (value: string) => {
    setCurrentBlogSearchTerm(value)
    // navigate(`?blog-search=${value}`, { replace: false })
    searchComponentModalToggleHandler()
  }

  useEffect(() => {
    if(typeof window !== "undefined"){
      const urlSlug = slug?.[0]?.replace(/-/g, " ");
      setNotFoundSlug(urlSlug)
    }
  }, [notFoundSlug, setNotFoundSlug, slug]);

  const formatButtons = (buttons: any) => {
    // console.log(buttons)
    return buttons?.map((button: any) => {
      return {
        label: button?.textLabel,
        destination: processLinkUrl(button?.destination || button),
        primary: button?.isPrimary ?? true,
      }
    })
  }

  const notFoundHeroData = {
    header: notFoundData?.header || "404 - Page Not Found",
    backgroundImage:  {
      title: `${notFoundData?.header} - background image` || "404 background image",
      url: notFoundData?.backgroundImage?.url || "//images.ctfassets.net/citn2sn5tdjr/7lTco8jlp0hd6AY0KliaG7/1b98ceac49e765c2d904265109a5421a/Hero_homepage.jpg",
    },

    description: notFoundData?.description || "<p>The page you are looking for does not exist.</p>",
    isHeaderBig: true,
    buttons:  formatButtons(notFoundData?.buttonsCollection?.items) || [
      {
        label: "Return Home",
        destination: "/en-US/homepage",
        primary: true,
      }
    ],
    isWrapped: true,
    searchComponent: (
      validSearchClient && (
        <div>
          <div className="t2-blog-digest__search-input">
            <SearchButton label={notFoundSlug || notFoundData?.searchFieldPlaceholder || "Search"} onSearch={handleSearch} autoPopulateText={notFoundSlug || null} />
          </div>
          <BlogArticleSearch
            locale={lang}
            articleSearchModalOpen={articleSearchModalOpen}
            setArticleSearchModalOpen={setArticleSearchModalOpen}
            title={notFoundData?.searchWindowTitle || "Search"}
            description={notFoundData?.searchWindowDescription || "Search for Articles, Case Studies, and more"}
            searchPlaceholderText={notFoundData?.searchFieldPlaceholder || 'Search for articles'}
            searchTerm={currentBlogSearchTerm}
            resetButtonText={notFoundData?.searchResetText || "Reset"}
            algoliaData={algoliaData}
            profile={profile}
          />
        </div>
      )
    )
  };

  return (
    <>
      <div className="not-found-page">
        <SimpleHero {...notFoundHeroData} />
      </div>
    </>
  )
}

export default NotFound;